import { Component, OnInit, ViewChild } from '@angular/core';
import { global } from '../../shared/global';
import { StaffLogin } from '../Models/stafflogin.model';
import { StaffloginService } from '../stafflogin/stafflogin.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-stafflogin',
  templateUrl: './stafflogin.component.html',
  styleUrls: ['./stafflogin.component.css']
})
export class StaffloginComponent implements OnInit {

  @ViewChild('staffLoginForm', { static: true }) staffLoginForm: NgForm;

  termConditionLink: any;
  data: StaffLogin;
  responseData: any;
  errorMessage: string = "";
  cookieValue: any;

  constructor(private service: StaffloginService, private router: Router, private cookieService: CookieService, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.spinner.hide();
    this.data = new StaffLogin();
    this.termConditionLink = global.termConditionLink;

    this.cookieValue = this.cookieService.get("staff");
    if (this.cookieValue) {
      this.router.navigate(["/shopkeeper"]);
    }
  }

  onSubmit(staffLogin: StaffLogin) {
    if (this.staffLoginForm.valid) {
      this.spinner.show();
      this.service.staffLogin(staffLogin)
        .subscribe(data => {
          this.responseData = data;
          if (this.responseData.isSuccess == false) {
            this.errorMessage = this.responseData.message;
            this.spinner.hide();
          }
          else {            
            var objData = {
              "asccode":this.responseData.asccode,
              "companyname":this.responseData.data.company_name,
              "companyid":this.responseData.data.company_id,
              "role":this.responseData.data.role,
              "customer_register":this.responseData.data.customer_register
            };

            this.cookieService.set("staff", JSON.stringify(objData));

            var objConfig = {
              "isStaff":1
            }
      
            this.cookieService.set("config", JSON.stringify(objConfig));

            this.errorMessage = "";
            this.spinner.hide();

            this.router.navigate(["/shopkeeper"]);
          }
        });
    } else {
    }
  }
}
